import BaseMapper from '../../BaseMapper';

const EventMarketRemoveMapper = (data, context) => {
    return data;
};

export default EventMarketRemoveMapper;
